// Components data will be here

const allcomponents = [
  {
    id: 1,
    name: "list group",
    tag: "list",
    icon: "list",
    subtag: "li",
    appliedOnlyOnce: false,
    canBeEdited: true,
    editText: "nonEditable",
    editSubtext: [
      "Sample bullet 1",
      "Sample bullet 2",
      "Sample bullet 3",
      "Sample bullet 4",
    ],
    editImg: "nonEditable",
    bootstrapTags: "ListGroup.Item",
  },
  {
    id: 2,
    name: "button",
    tag: "buntton",
    icon: "hand-pointer",
    subtag: "notApplicable",
    appliedOnlyOnce: false,
    canBeEdited: true,
    editText: "Sample button",
    editSubtext: "nonEditable",
    editImg: "nonEditable",
    bootstrapTags: "btn btn-primary",
  },
  {
    id: 3,
    name: "link",
    tag: "a",
    icon: "link",
    subtag: "notApplicable",
    appliedOnlyOnce: false,
    canBeEdited: true,
    editText: "Sample social link",
    editSubtext: "nonEditable",
    editImg: "nonEditable",
    bootstrapTags: "btn btn-success",
  },
  {
    id: 4,
    name: "Nav Bar",
    tag: "nav",
    icon: "address-card",
    subtag: "notApplicable",
    appliedOnlyOnce: true,
    canBeEdited: true,
    editText: "Sample header text",
    editSubtext: "nonEditable",
    editImg: "editable",
    bootstrapTags: "navbar navbar-expand-lg navbar-light bg-light",
  },
  {
    id: 5,
    name: "Text",
    tag: "div",
    icon: "text-height",
    subtag: ["h1", "p"],
    appliedOnlyOnce: false,
    canBeEdited: false,
    editText: "nonEditable",
    editSubtext: ["Title example", "lorem ipsum text"],
    editImg: "nonEditable",
    bootstrapTags: "",
  },
  {
    id: 6,
    name: "container",
    tag: "container",
    icon: "columns",
    subtag: "notApplicable",
    appliedOnlyOnce: false,
    canBeEdited: true,
    editText: "Sample container",
    editSubtext: "nonEditable",
    editImg: "nonEditable",
    bootstrapTags: "",
  },
];

export default allcomponents;
